<template>
  <div>
    <p id="savingMessage">Guardando tu información</p>
      <div class="pro-bar-container">
        <div class="pro-bar pro-bar-width" data-pro-bar-percent="80">
          <div class="pro-bar-candy"></div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name:'Loader'
}
</script>

<style>

</style>